import { api } from "../api";

/**
 * maintenanceTypesFindAllByActivated
 *
 * Busca os tipos de manutenção por status.
 *
 * GET /maintenances/types/{status}
 */
const maintenanceTypesFindAllByActivated = async (
    token: string,
    status: string
) => {
    const response = await api.get(
        `/maintenances/types/${status}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response;
};

export default maintenanceTypesFindAllByActivated;